import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
document.title = 'Aijentik — AI Agents Built for Real Industries';
(function () {
  const scriptId = 'sa-dynamic-optimization';
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.setAttribute('nowprocket', '');
    script.setAttribute('nitro-exclude', '');
    script.dataset.uuid = '21d384b3-a6ce-4854-9928-dcf62e6ed1e0';
    script.src = 'data:text/javascript;base64,dmFyIHNjcmlwdCA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoInNjcmlwdCIpO3NjcmlwdC5zZXRBdHRyaWJ1dGUoIm5vd3Byb2NrZXQiLCAiIik7c2NyaXB0LnNldEF0dHJpYnV0ZSgibml0cm8tZXhjbHVkZSIsICIiKTtzY3JpcHQuc3JjID0gImh0dHBzOi8vZGFzaGJvYXJkLnNlYXJjaGF0bGFzLmNvbS9zY3JpcHRzL2R5bmFtaWNfb3B0aW1pemF0aW9uLmpzIjtzY3JpcHQuZGF0YXNldC51dWlkID0gIjIxZDM4NGIzLWE2Y2UtNDg1NC05OTI4LWRjZjYyZTZlZDFlMCI7c2NyaXB0LmlkID0gInNhLWR5bmFtaWMtb3B0aW1pemF0aW9uLWxvYWRlciI7ZG9jdW1lbnQuaGVhZC5hcHBlbmRDaGlsZChzY3JpcHQpOw==';
    document.head.appendChild(script);
  }
})();
render(<BrowserRouter data-id="element-591">
    <App data-id="element-592" />
  </BrowserRouter>, document.getElementById('root'));